import HeaderMenuItem from "./HeaderMenuItem";
import { DASHBOARD } from "../../constants/routes"
import { useSelector } from "react-redux";

const HeaderUsersMenu = () => {
  const appSettings = useSelector(s => s.app_settings);
  const appName = appSettings.general?.app_name || '点検王';
    return (
      appName && (
        <div className="flex flex-row items-center space-x-[16px]">
          <HeaderMenuItem icon="header-tenken" menu={appName} app="users" link={DASHBOARD} />
        </div>
      )
    );
};

export default HeaderUsersMenu;
